const landingTypesList = [
  '/',
  '/fullPrice',
  '/trialb',
];

export default landingTypesList;
